import TextCard from 'Components/Reusable/Cards/TextCard';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { CommonButton } from 'Components/Reusable/Buttons/Buttons';
import Error from './Error';
import useMediaQuery from '@material-ui/core/useMediaQuery';
// redux and store imports
import { RootState } from 'ReduxStore/store';
import { generateNewToy, getToy, issueWithToy } from 'ReduxStore/toys/Action';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from './timeline.style';
import { Routes } from 'Utils/Route';
import { useHistory, Link } from 'react-router-dom';
import parse from 'html-react-parser';
import { changeIdentities, setActivitiesImage, shuffleItems } from 'Helpers';
import { ClipLoader } from 'react-spinners';
import { getAgeGroup } from 'ReduxStore/milestones/Action';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import Header from 'Components/Header/Header';
import { GetAllKids } from 'ReduxStore/children/Action';
const Timeline = () => {
	const [displayQue, setDisplayQue] = useState<any>(false)
	const dispatch = useDispatch();
	const classes = useStyles();
	const history = useHistory();
	const childName = localStorage.getItem('currentChild');
	const [loading, setLoading] = useState<boolean>(false);
	// const [plan, setPlan] = useState<boolean>(false)
	const ageGroupData = useSelector((state:RootState) => state.milestones.ageGroup)
	const toys = useSelector((state: RootState) => state.toys.toy);
	const issueMessage = useSelector((state: RootState) => state.toys.message);
	
	const errors = useSelector((state: RootState) => state.toys.error);

	
	const errorObj:any  = {}

	errorObj.message = errors?.message

	useEffect(() => {
		setLoading(true)
		dispatch(getToy());
		dispatch(getAgeGroup())
		dispatch(GetAllKids());
		process.env.REACT_APP_NODE_ENV != 'development' ?   setDisplayQue(toys?.showQuestionarre) : setDisplayQue(true)
		setLoading(false)
	}, []);
	
	const matches = useMediaQuery('(max-width:1169px)');
	// const children = useSelector((state: RootState) => state.children.children);
	const handleIssueWithToy = (id: number) => {
		issueWithToy(id)(dispatch);
	};
	const blocks = [
		'#86E3CE',
		'#D0E6A5',
		'#FFDD95',
		'#FC887B',
		'#A9BAF2',
	];
	const goBack = () => {
		history.push(Routes.Menu);
	};
	const handleSaveQuestion = (id: number) => {
		history.push(`/options/${id}`);
	};
	const customId = "";


	const getChildId = localStorage.getItem('currentChildId');
	const children = useSelector((state: RootState) => state.children.children);
	const child = children && children.find(child => child.id === (getChildId && parseInt(getChildId)));

	// child?.Subscriptions[0].plan != 'premium' ? setPlan(true)  : setPlan(false)

	// eslint-disable-next-line no-console
	console.log(child)
	
	return (
		<Fragment>
			<Header />
			
			{toys ? (
				<div>
					<h4 className="d-flex justify-content-center align-items-center my-5">Activities</h4>
					<section className="d-flex justify-content-center align-items-center my-5">
						
						<img className={classes.topImage} src={toys.toy.imageName && setActivitiesImage(toys.toy.imageName)} alt="" />
						
					</section>
					<h3 className="d-flex justify-content-center align-items-center my-5 mx-2">{toys.toy.name && changeIdentities(toys.toy.name,child?.fullName,child?.gender) }</h3>
					{/* <h4 className={  classes.goal}>{toys.toy.goal && parse(changeIdentities(toys.toy.goal,child?.fullName,child?.gender))}</h4> */}
					<div className={classes.boxContainer}>
						<ul className={classes.boxA}>
						<li>AGE: {ageGroupData?.monthsMin} Months</li>
							<li>TIME: {toys.toy.minutes} Minutes</li>
							<li style={{textAlign:'center'}}>{toys.toy.frequency}</li>
						</ul>
						
						<ul className={classes.boxB}>
							
						</ul>
						<ul className={classes.boxC}>
							<li>{parse(toys.toy.skills)}</li>
						</ul>
					</div>
					<h4 style={{textAlign:'center'}}>SUPPLIES</h4>
					<section className={classes.redBoxContainer}>
						
						<div className={classes.redBoxDiv}>
							<ul className={classes.supplies}>
								<li></li>
							</ul>
							<ul className={classes.supplies}>
								<li>{parse(changeIdentities(toys.toy.supplies,child?.fullName,child?.gender))}</li>
							</ul>
							<ul className={classes.supplies}>
								<li></li>
							</ul>
						</div>
					</section>
					<section>
						<div className="container pb-0">
							<div className="row">
								<div className="col-md-12 text-center">
									<div className="heading-line-bottom text-center">
										<h3 style={{ margin: '1rem 0' }}>Process</h3>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section id="cd-timeline" className="cd-container">
						{toys.toy.ToyActivityInstructions &&
							toys.toy.ToyActivityInstructions.map((toy, index) => (
								<TextCard
									key={toy.id}
									copy={changeIdentities(toy.task,  child?.fullName,child?.gender)}
									common={{ background: shuffleItems(blocks) }}
									number={index + 1}
								/>
							))}
					</section>
					<section className="d-flex justify-content-center flex-column align-items-center" style={{padding:'1rem'}}>
						<div
							className="d-flex justify-content-center"
							style={{
								margin: matches ? ' 0 1rem' : '',
							}}
						>
							<TextCard
								only
								common={{
									background: '#D0E6A5',
									radius: '4rem',
									height: 'auto',
								}}
							>
								<h5>Goal</h5>
								<p>{parse(changeIdentities(toys.toy.goal, childName, child?.gender))}</p>
							</TextCard>
						</div>
						{
							displayQue && 
							(
								<CommonButton
							onClick={() => handleSaveQuestion(toys.toy.id)}
							common={{
								width: '261px',
								height: '48px',
								background: '#7FD6DD',
								radius: '200px',
								margin: '0 auto',
								fontSize: '12px',
								padding: '1rem .8rem',
							}}
							command="COMPLETE THE ACTIVITIES AND QUESTIONNAIRE"
						/>
							)
						}
						<h4 className="py-3" style={{ fontFamily: 'Poppins', fontSize: '12px', textAlign: 'center' }}>
							If you have a problem with the toy or it has not been received yet, please click the below
							button
						</h4>

						<CommonButton
							onClick={() => handleIssueWithToy(toys.toy.id)}
							common={{
								width: '261px',
								height: '48px',
								background: '#FF7552',
								radius: '500px',
								margin: '0 auto',
								fontSize: '12px',
							}}
							command="ISSUE WITH THE TOY"
						/>


					</section>
				</div>
			) :    (
				<div className={classes.loading}>
					{errors ? (
						child && <Error errors={errorObj} id={child?.id} timeline={true}  plan={child} />
					) : (
						<div className={classes.loading}>
							<h4>Wait a moment ...</h4>
							<ClipLoader color={'#7FD6DD'} loading={true} size={50} />
						</div>
					)}
				</div>
						
					)
				
			}
			
			{
				issueMessage ? ( <div>
					{ toast(`${issueMessage.message}`, {
							toastId: customId,
							position: "top-center",
							autoClose: 5000,
							hideProgressBar: false,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true,
							progress: undefined,
							})}
					<ToastContainer />

				</div> ) : ''
			}
		</Fragment>
	);
};

export default Timeline;
